const addCardLinks = () => {
    document.querySelectorAll('[data-card-link]').forEach(item => {
        if (item.classList.contains('-marked')) {
            return;
        }
        item.classList.add('-marked');
        item.addEventListener('click', event => {
            let currentElement = event.target;
            let href = null;
            while (currentElement) {
                if (currentElement.hasAttribute('data-card-link-exclude')) {
                    break;
                }
                if (currentElement.hasAttribute('data-card-link')) {
                    href = currentElement.getAttribute('href');
                }
                currentElement = currentElement.parentElement;
            }
            if (href) {
                location.href = href;
            }
        });
    });
    setTimeout(() => {
        addCardLinks();
    }, 1000);
}
document.addEventListener('DOMContentLoaded', addCardLinks);